// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function inviteDecline(params: { invite_id: number }) {
  return http<{
    detail: string
  }>({
    url: "/api/v1/invites/{invite_id}/decline/",
    method: "post",
    params,
    pathParamNames: ["invite_id"],
  })
}
